<template>
  <div class="alert alert-dismissible fade show" :class="$props.class" role="alert">
    <div class="message">
      <slot />
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" v-if="closeable" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export type AlertType = 'alert-success' | 'alert-warning' | 'alert-danger' | 'alert-light';

export default defineComponent({
  name: 'AlertItem',
  props: {
    class: { type: String as PropType<AlertType>, default: null },
    closeable: { type: Boolean, default: false },
  },
});
</script>
